import Vue from 'vue'
import Router from 'vue-router'
import store from '../main.js'
import axios from 'axios';
import PropertyIndex from '@/components/PropertyIndex'
import PropertyDetail from '@/components/PropertyDetail'
import ApplicationLogin from '@/components/Application/ApplicationLogin'
import ApplicationRegister from '@/components/Application/ApplicationRegister'
import ApplicationUpdate from '@/components/Application/ApplicationUpdate'
import ApplicationIndex from '@/components/Application/ApplicationIndex'
import ApplicationDetail from '@/components/Application/ApplicationDetail'
import ApplicationResetPassword from '@/components/Application/ApplicationResetPassword'
import ApplicationSendResetPassword from '@/components/Application/ApplicationSendResetPassword'
import ApplicationFinish from '@/components/Application/ApplicationFinish'



Vue.use(Router)



const router = new Router({
  routes: [
    {
      path: '/available-properties',
      name: 'PropertyIndex',
      component: PropertyIndex,
      meta: { title: 'Available Properties' }

    },
    {
      path: '/available-properties/login',
      name: 'ApplicationLogin',
      component: ApplicationLogin,
      meta: { title: 'Login' }
    },
    {
      path: '/available-properties/logout',
      name: 'PropertyIndexLogout',
      component: PropertyIndex,
      meta: { title: 'Available Properties', logout: true }
    },
    {
      path: '/available-properties/register',
      name: 'ApplicationRegister',
      component: ApplicationRegister,
      meta: { title: 'Register' }
    },
    {
      path: '/available-properties/update',
      name: 'ApplicationUpdate',
      component: ApplicationUpdate,
      meta: { title: 'Update' }
    },
    {
      path: '/available-properties/verify-email',
      name: 'ApplicationLoginVerified',
      component: ApplicationLogin,
      meta: { title: 'Login', verified: true }
    },
    {
      path: '/available-properties/send-reset-password',
      name: 'ApplicationSendResetPassword',
      component: ApplicationSendResetPassword,
      meta: { title: 'Reset Password' }
    },
    {
      path: '/available-properties/reset-password',
      name: 'ApplicationResetPassword',
      component: ApplicationResetPassword,
      meta: { title: 'Reset Password' }
    },
    {
      path: '/available-properties/applications',
      name: 'ApplicationIndex',
      component: ApplicationIndex,
      meta: { requiresAuth: true, title: 'Application Status' }
    },
    {
      path: '/available-properties/applications/:property_id/:app_id',
      name: 'ApplicationFinish',
      component: ApplicationFinish,
      meta: { requiresAuth: true, title: 'Application for ' }
    },
    {
      path: '/available-properties/applications/:property_id',
      name: 'ApplicationDetail',
      component: ApplicationDetail,
      meta: { requiresAuth: true, title: 'Application for ' }
    },
    {
      path: '/available-properties/:id',
      name: 'PropertyDetail',
      component: PropertyDetail,
      meta: { title: 'Available Properties' }

    },
    
    
  ], 
  mode: 'history'
})

router.beforeResolve((to, from, next) => {
  if (to.meta.logout) {
    axios.post('/wp-json/HCLRC/v1/public-user-logout/'
        ).then(res => {
          store.commit('logout', store.state.token);
          location.reload();
          next({
            path: '/available-properties/'
          });

        })
        .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);

        });
    
  }
  
  else {
    next();
  }
})

// Setup Routing Middleware
router.beforeEach((to, from, next) => {
  // to and from are both route objects
  if (to.matched.some(record => record.meta.requiresAuth)) {
    axios.post('/wp-json/HCLRC/v1/check-user/')
    .then((response) => {

      if ( response.data.loggedIn == true ) {
        store.commit('login', response.data.token);
        next();
      } else {
        next({
          path: '/available-properties/login',
          query: {
            redirect: to.fullPath,
          },
        });
      }
       
    });
  }
  // Logout: Logout user and redirect to available properties
  // else if (to.meta.logout) {
  //   axios.post('/wp-json/HCLRC/v1/public-user-logout/'
  //       ).then(res => {
  //         store.commit('logout', store.state.token);
  //         location.reload();
  //         next({
  //           path: '/available-properties/'
  //         });

  //       })
  //       .catch(function (error) {
  //           // if an error occurs, print that error
  //           console.log(error);

  //       });
    
  // }

  // Email Verification: Verify user and redirect to available properties
  else if (to.meta.verified) {
    axios.post('/wp-json/HCLRC/v1/verify-public-user', {
      'username' : to.query.username,
      'verification_signature' : to.query.verification_signature,
      'epoch' : to.query.epoch
    }).then((response) => {
      if ( response.data.apiResponse.status == 'OK') {
        next({
          path: '/available-properties/login',
          query: {
            verified: true,
          },
        });
      } else {
        next({
          path: '/available-properties/login',
          query: {
            verified: false,
          },
        });
      }
    });
    
  }
  else {
    next();
  }
    
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js